export const isStringEmpty = (str?: string | null) => !str?.trim();

export function isStringNotEmpty(str: string): boolean {
  return !isStringEmpty(str);
}
